import React from 'react';
export function Testimonials() {
  return <section id="testimonials" className="py-16 bg-gray-50" data-id="element-560">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561">
        <div className="text-center mb-16" data-id="element-562">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4" data-id="element-563">
            What Business Owners Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-564">
            Don't just take our word for it — hear from the small businesses
            we've helped
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-565">
          {/* Testimonial 1 - Brittany */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-566">
            <div className="flex items-center mb-4" data-id="element-567">
              <div className="text-[#8A9A5B]" data-id="element-568">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-569">
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-570">
              "I'd been running everything in spreadsheets and was nervous about
              moving to QuickBooks. Jaime made the switch easy, helped set it
              up, explained everything, and showed me how to use it. Now I feel
              confident keeping up with my books."
            </blockquote>
            <div className="flex items-center" data-id="element-571">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-572">
                B
              </div>
              <div className="ml-4" data-id="element-573">
                <p className="font-medium text-[#3A4A46]" data-id="element-574">Brittany</p>
              </div>
            </div>
          </div>
          {/* Testimonial 2 - Scott */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-575">
            <div className="flex items-center mb-4" data-id="element-576">
              <div className="text-[#8A9A5B]" data-id="element-577">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-578">
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-579">
              "I used to stress over bookkeeping and the little details. Now I
              can just focus on running my business and doing what I love.
              Knowing the financial side is in good hands gives me peace of
              mind."
            </blockquote>
            <div className="flex items-center" data-id="element-580">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-581">
                S
              </div>
              <div className="ml-4" data-id="element-582">
                <p className="font-medium text-[#3A4A46]" data-id="element-583">Scott</p>
              </div>
            </div>
          </div>
          {/* Testimonial 3 - Taylor */}
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-584">
            <div className="flex items-center mb-4" data-id="element-585">
              <div className="text-[#8A9A5B]" data-id="element-586">
                {[...Array(5)].map((_, i) => <span key={i} className="text-2xl" data-id="element-587">
                    ★
                  </span>)}
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic" data-id="element-588">
              "I messed up my QuickBooks® and didn't know where to start. She
              cleaned everything up quickly, explained what was wrong, and
              showed me how to handle things correctly going forward. I
              completely trust her and wouldn't hesitate to recommend her
              services to any small business owner."
            </blockquote>
            <div className="flex items-center" data-id="element-589">
              <div className="h-12 w-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl" data-id="element-590">
                T
              </div>
              <div className="ml-4" data-id="element-591">
                <p className="font-medium text-[#3A4A46]" data-id="element-592">Taylor</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}